module.exports = __webpack_public_path__ + "public/Icons/8Managedrivers.svg?28bca1b3";